import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-detail-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryDetailTitleView = _resolveComponent("PantryDetailTitleView")
  const _component_PantryDetailDataView = _resolveComponent("PantryDetailDataView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PantryDetailTitleView, {
      "v-bind": _ctx.info,
      type: _ctx.type,
      name: _ctx.getName(),
      imageUrl: _ctx.getImage(),
      stock: _ctx.getStock(),
      plateName: _ctx.getPlateName(),
      showLowBattery: _ctx.isShowLowBattery(),
      data: _ctx.getPlateData(),
      onClickUpdatePlate: _ctx.onUpdatePlate
    }, null, 8, ["v-bind", "type", "name", "imageUrl", "stock", "plateName", "showLowBattery", "data", "onClickUpdatePlate"]),
    _createVNode(_component_PantryDetailDataView, {
      "v-bind": _ctx.info,
      type: _ctx.type,
      updateDate: _ctx.getUpdateDate(),
      purchaseDate: _ctx.getPurchaseDate(),
      expirationDate: _ctx.getExpirationDate(),
      notificationDate: _ctx.getNotificationDate(),
      stockQuantity: _ctx.getStockQuantity(),
      notificationStock: _ctx.getNotificationStock(),
      plateData: _ctx.getPlateData(),
      storage: _ctx.getStorege(),
      isShowData: _ctx.isShowData,
      onShowDataSetting: _ctx.onShowDataSetting,
      onChangeValue: _ctx.onChangeValue,
      onShowGuide: _ctx.onShowGuide
    }, null, 8, ["v-bind", "type", "updateDate", "purchaseDate", "expirationDate", "notificationDate", "stockQuantity", "notificationStock", "plateData", "storage", "isShowData", "onShowDataSetting", "onChangeValue", "onShowGuide"])
  ]))
}